"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderDays = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var function_2 = require("fp-ts/function");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var string_1 = require("../../library/string");
var Icon_1 = require("../Icon");
var formatMonthForTitle = function (date) { return date.format('MMMM'); };
var isDayOutOfBound = function (day, lowerBound, upperBound) {
    if (lowerBound && lowerBound.isAfter(day)) {
        return true;
    }
    if (upperBound && upperBound.isBefore(day)) {
        return true;
    }
    return false;
};
var buildActiveProp = function (selectedDays, day, pickerType) {
    if ((0, function_2.pipe)(selectedDays.endDate, O.isNone) &&
        (0, function_2.pipe)(selectedDays.startDate, O.isNone) &&
        (0, moment_timezone_1.default)([]).isSame(day, pickerType)) {
        return 'selected-current-day';
    }
    if ((0, function_2.pipe)(selectedDays.endDate, O.isNone) &&
        (0, function_2.pipe)(selectedDays.startDate, O.filter(function (s) { return s.isSame(day, pickerType); }), O.isSome)) {
        return 'selected-start-alone';
    }
    if ((0, function_2.pipe)(selectedDays.startDate, O.filter(function (s) { return s.isSame(day, pickerType); }), O.isSome) &&
        (0, function_2.pipe)(selectedDays.endDate, O.filter(function (s) { return s.isSame(day, pickerType); }), O.isSome)) {
        return 'selected-start-alone';
    }
    if ((0, function_2.pipe)(selectedDays.startDate, O.filter(function (s) { return s.isSame(day, pickerType); }), O.isSome)) {
        return 'selected-start';
    }
    if ((0, function_2.pipe)(selectedDays.endDate, O.filter(function (s) { return s.isSame(day, pickerType); }), O.isSome)) {
        return 'selected-end';
    }
    if ((0, function_2.pipe)(selectedDays.startDate, O.filter(function (s) { return s.isBefore(day, pickerType); }), O.isSome) &&
        (0, function_2.pipe)(selectedDays.endDate, O.filter(function (s) { return s.isAfter(day, pickerType); }), O.isSome)) {
        return 'selected';
    }
    return;
};
var buildFirstLine = function (pickerType, selectedDays, setSelectedDays, lowerBound, upperBound) { return [
    lowerBound &&
        ((pickerType === 'day' && lowerBound.isSame(selectedDays.viewDate, 'month')) ||
            (pickerType === 'month' && lowerBound.isSame(selectedDays.viewDate, 'year'))) ? ((0, jsx_runtime_1.jsx)("div", { className: "col col-1 bound" }, "prev")) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "col col-1", onClick: function () {
            return setSelectedDays(__assign(__assign({}, selectedDays), { viewDate: selectedDays.viewDate.clone().subtract(1, pickerType === 'day' ? 'month' : 'year') }));
        } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "icon_arrow_left_dark" }) }), "prev")),
    (0, jsx_runtime_1.jsx)("div", __assign({ className: "col col-2" }, { children: (0, jsx_runtime_1.jsx)("div", { children: pickerType === 'day'
                ? "".concat((0, function_1.flow)(formatMonthForTitle, string_1.capitalizeFirstLetter)(selectedDays.viewDate), " ").concat(selectedDays.viewDate.format('YYYY'))
                : selectedDays.viewDate.format('YYYY') }) }), "currentYear"),
    upperBound &&
        ((pickerType === 'day' && upperBound.isSame(selectedDays.viewDate, 'month')) ||
            (pickerType === 'month' && upperBound.isSame(selectedDays.viewDate, 'year'))) ? ((0, jsx_runtime_1.jsx)("div", { className: "col col-3 bound" }, "next")) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "col col-3", onClick: function () {
            return setSelectedDays(__assign(__assign({}, selectedDays), { viewDate: selectedDays.viewDate.clone().add(1, pickerType === 'day' ? 'month' : 'year') }));
        } }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "icon_arrow_right_dark" }) }), "next")),
]; };
var buildWeekdays = function (selectedDays) {
    return new Array(7)
        .fill(null)
        .map(function (_, i) { return selectedDays.viewDate.clone().startOf('week').add(i, 'day').locale('It'); })
        .map(function (d) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "col-day week-day col-no-click" }, { children: (0, string_1.capitalizeFirstLetter)(d.format('dd')) }), d.format('dd'))); });
};
var buildPrevDays = function (selectedDays) {
    return (0, function_2.pipe)(O.some(selectedDays.viewDate.clone().startOf('month').day()), O.map(function (d) { return (d === 0 ? 7 : d); }), O.map(function (d) {
        return new Array(d - 1)
            .fill(null)
            .map(function (_, i) {
            return selectedDays.viewDate
                .clone()
                .startOf('month')
                .subtract(d - 1 - i, 'days');
        })
            .map(function (day, index) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "col-day col-no-click" }, { children: (0, jsx_runtime_1.jsx)("div", { className: "empty" }) }), day.format('DD') + index)); });
    }), O.getOrElse(function () { return []; }));
};
var buildDaysInMonth = function (pickerType, selectedDays, handleClick, lowerBound, upperBound) {
    return new Array(selectedDays.viewDate.daysInMonth())
        .fill(null)
        .map(function (_, i) { return selectedDays.viewDate.clone().startOf('month').add(i, 'days'); })
        .map(function (day) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('col-day', buildActiveProp(selectedDays, day, pickerType), isDayOutOfBound(day, lowerBound, upperBound) ? 'col-day-out-bound' : ''), onClick: function () { return !isDayOutOfBound(day, lowerBound, upperBound) && handleClick(day); } }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: buildActiveProp(selectedDays, day, pickerType) }, { children: (0, jsx_runtime_1.jsx)("span", { children: day.format('DD') }) })) }), day.format('DD'))); });
};
var buildMonthInYear = function (pickerType, selectedDays, handleClick, lowerBound, upperBound) {
    return new Array(12)
        .fill(null)
        .map(function (_, i) { return selectedDays.viewDate.clone().startOf('year').add(i, 'month'); })
        .map(function (month) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('col-month', buildActiveProp(selectedDays, month, pickerType), isDayOutOfBound(month, lowerBound, upperBound) ? 'col-month-out-bound' : ''), onClick: function () { return !isDayOutOfBound(month, lowerBound, upperBound) && handleClick(month); } }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: buildActiveProp(selectedDays, month, pickerType) }, { children: (0, jsx_runtime_1.jsx)("span", { children: month.format('MMM') }) })) }), month.format('MMM'))); });
};
var buildNewMonthDays = function (selectedDays) {
    return (0, function_2.pipe)(O.some(selectedDays.viewDate.clone().endOf('month').day()), O.filter(function (d) { return d !== 7 && d !== 0; }), O.map(function (d) {
        return new Array(7 - d)
            .fill(null)
            .map(function (_, i) {
            return selectedDays.viewDate
                .clone()
                .endOf('month')
                .add(i + 1, 'days');
        })
            .map(function (day, index) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "col-day col-no-click" }, { children: (0, jsx_runtime_1.jsx)("div", { className: "empty" }) }), day.format('DD') + index)); });
    }), O.getOrElse(function () { return []; }));
};
var renderDays = function (pickerType, selectedDays, setSelectedDays, handleClick, lowerBound, upperBound) {
    return pickerType === 'day'
        ? __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], buildFirstLine(pickerType, selectedDays, setSelectedDays, lowerBound, upperBound), true), buildWeekdays(selectedDays), true), buildPrevDays(selectedDays), true), buildDaysInMonth(pickerType, selectedDays, handleClick, lowerBound, upperBound), true), buildNewMonthDays(selectedDays), true) : __spreadArray(__spreadArray([], buildFirstLine(pickerType, selectedDays, setSelectedDays, lowerBound, upperBound), true), buildMonthInYear(pickerType, selectedDays, handleClick, lowerBound, upperBound), true);
};
exports.renderDays = renderDays;
//# sourceMappingURL=datePickerElements.js.map